var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletterBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1170,
    height: 348,
    viewBox: "0 0 1170 348",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1124.68 322.386C765.18 356.167 404.795 356.167 45.3912 322.386C26.7641 320.533 7.84297 296.444 4.9999 269.076C-1.66663 205.219 -1.66663 142.502 4.9999 78.6454C7.84297 51.2781 26.7641 27.1891 45.3912 25.3361C404.893 -8.44538 765.278 -8.44538 1124.68 25.3361C1143.31 27.1891 1162.23 51.2781 1165.07 78.6454C1171.64 142.502 1171.64 205.219 1165.07 269.076C1162.23 296.444 1143.31 320.533 1124.68 322.386Z",
    fill: "#90C040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterBg);
export default __webpack_public_path__ + "static/media/newsletter-bg.50e6f2293face1a5622f3f93ced460b6.svg";
export { ForwardRef as ReactComponent };